import { ViewContainerRef } from '@angular/core';

export interface AddOnHost {
  vcRef: ViewContainerRef;
}
